/* Atelier intake v1. Native Shopify contact POST; isolated from MEN/DONNA. */
(function () {
  'use strict';
  var FORM = 'AtelierContactForm', KEY = 'atelierPending_v1:', TTL = 600000;
  var PIXEL = '367238364304147', GA4 = 'G-778ZPH76RS';
  var ADS = 'AW-952752129/8RmwCLOlza8dEIGwp8YD';
  var form = document.getElementById(FORM);
  if (!form || document.querySelectorAll('form#' + FORM).length !== 1 ||
      !/^https:\/\/(www\.)?(?:consiglieri\.ro|consiglierimen\.com)$/.test(location.origin) ||
      !/^\/(?:en\/)?pages\/atelier(?:-(?:timisoara|constanta|bucuresti))?\/?$/.test(location.pathname)) return;
  var localMatch = location.pathname.match(/\/atelier-(timisoara|constanta|bucuresti)\/?$/);
  var localCity = localMatch ? localMatch[1] : null;
  var renderedCity = typeof form.getAttribute === 'function' ? form.getAttribute('data-atelier-city') : null;
  // A local template must correspond to the route, including on the confirmation page.
  if (localCity !== (renderedCity || null)) return;
  var key = KEY + location.pathname, origin = location.origin, path = location.pathname;
  function qaURL() {
    try { var q = new URL(location.href).searchParams;
      return ['atelier_qa','preview_theme_id','webPixelDebug','cs_qa','cs_test_event'].some(function (k) { return q.has(k); });
    } catch (_) { return true; }
  }
  function clear() { try { sessionStorage.removeItem(key); } catch (_) {} }
  function field(name, value) {
    var input = form.elements.namedItem('contact[' + name + ']');
    if (input) input.value = value;
  }
  var success = form.querySelector('[data-atelier-success="true"]');
  if (!success) {
    // A new/error form must not inherit an earlier pending attempt.
    clear();
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented || !form.checkValidity()) return;
      clear();
      try {
        var city = {'Timișoara':'timisoara','Constanța':'constanta','București':'bucuresti'}[form.elements.namedItem('contact[Atelier]').value];
        if (localCity && (city !== localCity || form.elements.namedItem('contact[Atelier city]').value !== localCity)) return;
        if (!city || !window.crypto || !window.crypto.getRandomValues) return;
        var bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
        var id = 'atelier_' + Array.prototype.map.call(bytes, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        var qa = qaURL();
        field('Atelier reference', id); field('Atelier city', city);
        field('Atelier test', qa ? 'TEST TEHNIC — nu contactati; nu creati programare' : 'nu');
        sessionStorage.setItem(key, JSON.stringify({v:1,id:id,ts:Date.now(),origin:origin,path:path,city:city,qa:qa,formId:'atelier_request'}));
      } catch (_) { clear(); }
      // Never prevent the native business request if analytics/storage are unavailable.
    });
    return;
  }
  var record;
  try {
    if (location.hash !== '#' + FORM || success.closest('form') !== form) return;
    var raw = sessionStorage.getItem(key);
    if (!raw || raw.length > 1000) return;
    record = JSON.parse(raw);
    var now = Date.now();
    if (!record || record.v !== 1 || !/^atelier_[a-f0-9]{32}$/.test(record.id) ||
        record.origin !== origin || record.path !== path || record.formId !== 'atelier_request' ||
        ['timisoara','constanta','bucuresti'].indexOf(record.city) === -1 || (localCity && record.city !== localCity) || typeof record.qa !== 'boolean' ||
        !Number.isSafeInteger(record.ts) || record.ts > now || now-record.ts > TTL) { clear(); return; }
    // Consume before dispatch, across reload/back and duplicate script execution.
    sessionStorage.removeItem(key);
    if (sessionStorage.getItem(key) !== null) return;
  } catch (_) { return; }
  if (record.qa || qaURL()) return;
  // The success marker is Shopify's response, bound to a recent same-tab submission.
  // This is browser confirmation, not a server-signed receipt or a CRM booking.
  var stopped = false, start = Date.now(), gaDone = false, adsDone = false, metaDone = false;
  var ownedFbq = null, timer = null, loadRequested = false;
  var data = {service_type:'atelier',form_id:'atelier_request',atelier_city:record.city,atelier_event:'lead_confirmed'};
  function consent(kind) {
    try {
      var p = window.Shopify && window.Shopify.customerPrivacy;
      var fn = kind === 'analytics' ? 'analyticsProcessingAllowed' : 'marketingAllowed';
      if (!p || typeof p[fn] !== 'function') return null;
      if (p[fn]() !== true) return false;
      if (kind === 'marketing' && (typeof p.saleOfDataAllowed !== 'function' || p.saleOfDataAllowed() !== true)) return false;
      return true;
    } catch (_) { return false; }
  }
  function stop() { stopped = true; if (timer) clearTimeout(timer); }
  window.addEventListener('pagehide', stop, {once:true});
  function googleReady() { return !!(window.google_tag_manager && window.google_tag_manager['GTM-MBTQT7']); }
  function gtag() { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); }
  function meta() {
    if (consent('marketing') !== true || metaDone) return;
    if (!window.fbq) {
      var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!window._fbq) window._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = []; ownedFbq = n;
      n('consent','revoke');
      var s = document.createElement('script'); s.async = true; s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(s);
    }
    if (typeof window.fbq.callMethod !== 'function' || consent('marketing') !== true) return;
    if (ownedFbq === window.fbq) window.fbq('consent','grant');
    if (!window.__csMetaInit) { window.fbq('init', PIXEL, {}); window.__csMetaInit = true; }
    if (consent('marketing') !== true) return;
    metaDone = true;
    // Meta custom conversion 1448571077384073 requires PageView + this exclusive parameter.
    // Only this qualified confirmation carries atelier_event; ordinary page visits never do.
    window.fbq('trackSingle', PIXEL, 'PageView', data, {eventID:record.id});
  }
  function tick() {
    if (stopped || Date.now()-start > 5000 || location.origin !== origin || location.pathname !== path ||
        location.hash !== '#' + FORM || !form.isConnected) { stop(); return; }
    var a = consent('analytics'), m = consent('marketing');
    // Explicit denial ends this attempt; later consent does not replay a past lead.
    if (a === false) gaDone = true;
    if (m === false) {
      adsDone = metaDone = true;
      if (ownedFbq && window.fbq === ownedFbq) window.fbq('consent','revoke');
    }
    if (googleReady()) {
      if (!gaDone && consent('analytics') === true) {
        gaDone = true;
        gtag('event','atelier_lead',{send_to:GA4,event_id:record.id,service_type:'atelier',form_id:'atelier_request',atelier_city:record.city});
      }
      if (!adsDone && consent('marketing') === true) {
        adsDone = true;
        gtag('event','conversion',{send_to:ADS,transaction_id:record.id});
      }
    }
    if (!metaDone && m === true) meta();
    if ((a === null || m === null) && !loadRequested && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      loadRequested = true;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function () {});
    }
    if (gaDone && adsDone && metaDone) { stop(); return; }
    timer = setTimeout(tick,100);
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (consent('marketing') === false && ownedFbq && window.fbq === ownedFbq) window.fbq('consent','revoke');
  });
  tick();
}());
